import React, { useRef } from "react";
import { VerificationInputFieldContainer } from "./styles";

const VerificationInputField = ({
  className,
  label,
  width,
  isRequired,
  length,
  labelPosition,
  labelColor,
  labelSize,
  labelWeight,
  inputFontSize,
  inputFontWeight,
  inputColor,
  inputBackgroundColor,
  borderColor,
  inputHeight,
  inputWidth,
  margin,
  error,
  errorMessage,
  success,
  values,
  setValues,
}) => {
  const inputsRef = useRef([]);

  const handleChange = (e, index) => {
    const { value } = e.target;
    // Handle multi-character input (paste or autofill)
    if (value.length > 1) {
      const chars = value.replace(/[^a-zA-Z0-9]/g, "").toUpperCase().split("");
      const newValues = [...values];

      chars.forEach((char, i) => {
        if (index + i < length) {
          newValues[index + i] = char;
        }
      });

      setValues(newValues);

      const nextIndex = Math.min(index + chars.length, length - 1);
      inputsRef.current[nextIndex]?.focus();
      return;
    }

    if (/^[a-zA-Z0-9]$/.test(value) || value === "") {
      const newValues = [...values];
      newValues[index] = value.toUpperCase();
      setValues(newValues);
      if (value !== "" && index < length - 1) {
        inputsRef.current[index + 1]?.focus();
      }
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();

    const pasteData = e.clipboardData.getData("text").trim();

    // Keep only alphanumeric and uppercase it
    const sanitized = pasteData.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();

    if (!sanitized) return;

    const newValues = [...values];

    for (let i = 0; i < length; i++) {
      newValues[i] = sanitized[i] || "";
    }

    setValues(newValues);

    // Focus the last filled input (or last input if full)
    const nextIndex = Math.min(sanitized.length, length) - 1;
    if (nextIndex >= 0) {
      inputsRef.current[nextIndex]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && values[index] === "" && index > 0) {
      inputsRef.current[index - 1]?.focus();
    }
  };

  return (
    <VerificationInputFieldContainer
      className={className}
      labelPosition={labelPosition}
      labelColor={labelColor}
      labelSize={labelSize}
      labelWeight={labelWeight}
      borderColor={borderColor}
      inputHeight={inputHeight}
      inputWidth={inputWidth}
      inputColor={inputColor}
      inputFontSize={inputFontSize}
      inputFontWeight={inputFontWeight}
      inputBackgroundColor={inputBackgroundColor}
      success={success}
      width={width}
      margin={margin}
    >
      {label ? (
        <label>
          {label}
          {isRequired ? <span className="required"> *</span> : null}
        </label>
      ) : null}
      <div className="blockContainer">
        {Array.from({ length }).map((_, idx) => (
          <input
            key={idx}
            type="text"
            maxLength={1}
            value={values[idx]}
            onChange={(e) => handleChange(e, idx)}
            onKeyDown={(e) => handleKeyDown(e, idx)}
            onPaste={handlePaste}
            ref={(el) => (inputsRef.current[idx] = el)}
          />
        ))}
      </div>
      {error && <div className="warning">{errorMessage}</div>}
    </VerificationInputFieldContainer>
  );
};

export default VerificationInputField;
